<template>
  <svg
    width="149"
    height="206"
    viewBox="0 0 149 206"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer_1" clip-path="url(#clip0_2787_13319)">
      <g id="Group">
        <path
          id="Vector"
          d="M129.926 180.099C129.926 193.014 109.715 203.711 83.2646 205.683C80.416 205.888 77.4858 206.001 74.5002 206.001C51.0761 206.001 31.0429 199.21 22.9258 189.608C20.4387 186.665 19.0742 183.464 19.0742 180.099C19.0742 166.979 39.9821 156.126 67.0712 154.423C69.497 154.278 71.984 154.197 74.5002 154.197C98.0118 154.197 118.106 161.041 126.153 170.691C128.591 173.614 129.926 176.786 129.926 180.096V180.099Z"
          fill="#CBC9C7"
        />
        <path
          id="Vector_2"
          d="M142.752 86.0703L141.524 105.58L140.67 119.191L138.119 159.52L137.69 166.41H137.676C137.676 177.428 124.771 187.02 105.645 192.112C99.2069 193.812 92.0724 195.012 84.4859 195.57C81.2409 195.807 77.8996 195.931 74.4941 195.931C47.7928 195.931 24.9635 188.191 15.7064 177.246C12.8753 173.886 11.3126 170.246 11.3126 166.41L10.884 159.549L8.34738 119.206L7.4931 105.583L6.26562 86.0732H142.755L142.752 86.0703Z"
          fill="#FEFEFE"
        />
        <path
          id="Vector_3"
          d="M140.67 119.19L138.119 159.519C132.521 166.518 121.757 172.35 107.998 176.001C101.064 177.843 93.3964 179.124 85.2356 179.725C81.7485 179.977 78.1564 180.116 74.4973 180.116C45.7784 180.116 21.226 171.789 11.275 160.019C11.1408 159.866 11.0067 159.713 10.8872 159.545L8.35059 119.202C22.2435 129.425 46.6619 136.202 74.4973 136.202C78.7191 136.202 82.8593 136.049 86.88 135.757C96.2829 135.06 105.126 133.583 113.115 131.46C124.322 128.491 133.792 124.25 140.673 119.188L140.67 119.19Z"
          fill="#683C11"
        />
        <path
          id="Vector_4"
          d="M142.752 86.0703L141.524 105.58C133.777 113.027 120.541 118.966 104.283 122.285C98.618 123.441 92.5826 124.294 86.2761 124.754C82.4421 125.02 78.5147 125.188 74.4941 125.188C45.0521 125.188 19.5813 117.196 7.49017 105.58L6.2627 86.0703H142.752Z"
          fill="#AEA6A0"
        />
        <path
          id="Vector_5"
          d="M149 53.8588V79.911C149 94.1817 130.617 106.455 104.286 111.829C98.6209 112.983 92.5798 113.83 86.2791 114.295C82.448 114.564 78.5206 114.726 74.5 114.726C43.0229 114.726 16.0913 105.596 5.18398 92.6869C1.83393 88.7347 0 84.4269 0 79.9139V53.8617H25.1181C35.9205 49.3834 49.5073 46.3505 64.5198 45.408C67.7766 45.2114 71.115 45.1016 74.5 45.1016C79.8006 45.1016 84.9729 45.3589 89.9674 45.8619C102.802 47.1254 114.429 49.9356 123.891 53.8617H148.997L149 53.8588Z"
          fill="#CBC9C7"
        />
        <path
          id="Vector_6"
          d="M148.997 53.8533C148.997 71.2118 121.832 85.5923 86.2791 88.2377C82.448 88.5124 78.5148 88.6656 74.5 88.6656C43.0171 88.6656 16.0884 79.5383 5.18106 66.6351C1.83684 62.6771 0 58.3751 0 53.8533C0 36.2202 28.1066 21.6344 64.514 19.3446C67.7766 19.1509 71.1179 19.041 74.4971 19.041C106.1 19.041 133.107 28.2378 143.924 41.2103C147.198 45.1394 148.994 49.4009 148.994 53.8533H148.997Z"
          fill="#FEFEFE"
        />
        <path
          id="Vector_7"
          d="M145.859 48.6816C145.859 58.2166 137.302 66.8177 123.584 72.892C113.371 77.4196 100.312 80.5507 85.783 81.6291C82.1151 81.8864 78.3423 82.0338 74.4995 82.0338C44.3374 82.0338 18.5487 73.2968 8.09911 60.9285C7.88627 60.6827 7.68801 60.437 7.48683 60.1912C4.67617 56.6091 3.13672 52.7436 3.13672 48.6816C3.13672 47.0249 3.40787 45.3914 3.91227 43.7984H3.90061L8.69681 27.1599H20.0386C20.8141 26.7291 21.6247 26.3128 22.4469 25.8964C33.4125 20.4235 48.2472 16.6939 64.9275 15.6386C68.0531 15.4536 71.2515 15.3438 74.4966 15.3438C93.5035 15.3438 110.782 18.816 123.561 24.4971C125.476 25.3327 127.275 26.226 128.981 27.1599H140.311L145.095 43.7984H145.084C145.588 45.3943 145.859 47.0249 145.859 48.6816Z"
          fill="#AEA6A0"
        />
        <path
          id="Vector_8"
          d="M140.808 30.9844C140.808 46.4347 116.628 59.2338 84.9851 61.5901C81.5767 61.8358 78.0721 61.9717 74.5005 61.9717C46.4784 61.9717 22.512 53.8476 12.803 42.3611C9.82904 38.8397 8.19629 35.0118 8.19629 30.9844C8.19337 15.2913 33.2065 2.30714 65.6136 0.268877C68.5176 0.098299 71.4915 0 74.5005 0C102.627 0 126.667 8.18484 136.294 19.7321C139.21 23.2304 140.808 27.0207 140.808 30.9844Z"
          fill="#CBC9C7"
        />
        <path
          id="Vector_9"
          d="M119.59 30.9844C119.59 33.439 118.532 35.7837 116.593 37.9434C113.503 41.3781 108.187 44.3618 101.394 46.533C93.8834 48.9269 84.5738 50.3378 74.5003 50.3378C62.5579 50.3378 51.7089 48.3487 43.6443 45.099C38.7431 43.1244 34.8741 40.6813 32.4191 37.9463C30.4802 35.7866 29.4219 33.4419 29.4219 30.9873C29.4219 23.135 40.3292 16.3841 55.9978 13.3542C61.6395 12.2498 67.9052 11.6484 74.5003 11.6484C90.1339 11.6484 103.91 15.06 111.998 20.238C116.794 23.3171 119.59 27.012 119.59 30.9873V30.9844Z"
          fill="#AEA6A0"
        />
        <path
          id="Vector_10"
          d="M107.281 31.6097C112.541 33.9978 112.541 41.8935 107.281 44.2816C99.0616 48.0141 87.4137 50.3414 74.5004 50.3414C61.5871 50.3414 49.9421 48.0141 41.7288 44.2816C36.4719 41.8935 36.4719 34.0007 41.7288 31.6126C49.945 27.8801 61.5871 25.5527 74.5004 25.5527C87.4137 25.5527 99.0616 27.8801 107.281 31.6126V31.6097Z"
          fill="#CBC9C7"
        />
        <path
          id="Vector_11"
          d="M140.671 119.189L138.119 159.518C132.521 166.518 121.757 172.349 107.998 176C107.663 176.084 107.316 176.183 106.983 176.252L110.736 132.061C111.538 131.864 112.325 131.671 113.112 131.462C124.32 128.493 133.79 124.252 140.671 119.189Z"
          fill="#432918"
        />
      </g>
      <path
        id="Vector_12"
        d="M114.129 52.8221C117.885 51.5963 125.395 48.5953 131.97 42.6135C133.894 40.8615 132.731 37.661 130.124 37.4586L123.322 36.9266C122.407 36.8543 121.506 37.2388 120.952 37.9645C119.544 39.8177 116.284 43.4577 111.05 45.6434C109.677 46.2159 109.097 47.8407 109.721 49.1822L110.718 51.3361C111.313 52.6197 112.779 53.2674 114.132 52.825L114.129 52.8221Z"
        fill="#432918"
      />
    </g>
    <defs>
      <clipPath id="clip0_2787_13319">
        <rect width="149" height="206" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
